var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"content",staticStyle:{"position":"relative"}},[_c('EChart',{ref:"chart",staticClass:"chart",attrs:{"options":_vm.option,"width":`${_vm.size}px`,"height":`${_vm.size}px`}}),_c('div',{staticClass:"innerContent"},[_vm._t("default")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }